import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // This is a placeholder - in a real app, you would fetch this from your authentication system
  useEffect(() => {
    // For demo, get user from localStorage or default to a role
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    } else {
      // Default user for testing 
      const defaultUser = {
        id: 1,
        name: localStorage.getItem('username') || 'mbotee',
        role: 'owner' // 'owner', 'general_manager', 'manager', 'staff', etc.
      };
      setCurrentUser(defaultUser);
      localStorage.setItem('currentUser', JSON.stringify(defaultUser));
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      // Mock login for demo purposes
      // In production, this would call your API
      if (username && password) {
        const user = {
          id: 1,
          name: username,
          role: username === 'admin' ? 'owner' : 'manager'
        };
        localStorage.setItem('currentUser', JSON.stringify(user));
        setCurrentUser(user);
        return user;
      }
      throw new Error('Invalid credentials');
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('currentUser');
    setCurrentUser(null);
  };

  const value = {
    currentUser,
    login,
    logout,
    isAdmin: currentUser && ['owner', 'general_manager'].includes(currentUser.role)
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};